module.exports = __webpack_public_path__ + "img/Toolmanagementsystem_mehrfarbig_RGB.497d495c.svg";